import { defineVideoTemplate } from "@assets/templates/builders";
import { BASE_ASSETS } from "@assets/templates/constants";

export const humanoidVideoExample = defineVideoTemplate({
  slug: "humanoid-video-example",
  title: "Humanoid",
  description: "Action sequencing",
  subdescription: "Break a robotic episode into clipped sub-tasks",
  poster: BASE_ASSETS.humanoidVideoPoster,
  video: BASE_ASSETS.humanoidVideo,
  prompt:
    "Describe this robotic task episode into a sequence of sub-tasks. Use the <clip> tag to specify each sub-task.",
  annotationFormat: "clip",
  enableThinking: true,
});
